/* Popular Categories — auto-fit the cut-out images.
   Many uploaded images carry large transparent or near-white margins with
   the subject off-center, so the CSS contain-box shows a small, drifting
   subject. After each image loads, measure the subject's real bounding box
   on a small canvas and publish CSS vars (--fit-clip / --fit-s / --fit-dx/dy)
   that clip the empty margins and scale + recenter the subject inside the
   circle's --img-scale box. Everything is expressed in percentages of the
   element box, so the values survive resizes and img_scale changes. */
(function () {
  'use strict';

  var SAMPLE = 80;        /* longest measuring-canvas side, px */
  var ALPHA_EMPTY = 10;   /* alpha below this counts as empty */
  var WHITE_EMPTY = 248;  /* r,g,b all >= this counts as empty (white bg) */
  var FULL_BBOX = 0.92;   /* subject covers this much of the file: no-op */
  var MAX_SCALE = 2.5;    /* upscale cap, keeps low-res images acceptable */

  function measure(img) {
    var w = img.naturalWidth, h = img.naturalHeight;
    if (!w || !h) return null;
    var cw = w >= h ? SAMPLE : Math.max(1, Math.round(SAMPLE * w / h));
    var ch = w >= h ? Math.max(1, Math.round(SAMPLE * h / w)) : SAMPLE;
    var canvas = document.createElement('canvas');
    canvas.width = cw;
    canvas.height = ch;
    var ctx = canvas.getContext('2d', { willReadFrequently: true });
    var data;
    try {
      ctx.drawImage(img, 0, 0, cw, ch);
      data = ctx.getImageData(0, 0, cw, ch).data;
    } catch (e) {
      return null; /* CORS-tainted canvas — leave the image as-is */
    }
    var x0 = cw, y0 = ch, x1 = -1, y1 = -1;
    for (var y = 0; y < ch; y++) {
      for (var x = 0; x < cw; x++) {
        var i = (y * cw + x) * 4;
        if (data[i + 3] < ALPHA_EMPTY) continue;
        if (data[i] >= WHITE_EMPTY && data[i + 1] >= WHITE_EMPTY && data[i + 2] >= WHITE_EMPTY) continue;
        if (x < x0) x0 = x;
        if (x > x1) x1 = x;
        if (y < y0) y0 = y;
        if (y > y1) y1 = y;
      }
    }
    if (x1 < 0) return null; /* fully empty (shouldn't happen) */
    return {
      fx0: x0 / cw, fx1: (x1 + 1) / cw,
      fy0: y0 / ch, fy1: (y1 + 1) / ch,
      ratio: w / h
    };
  }

  function apply(img) {
    var m = measure(img);
    if (!m) return;
    if (m.fx1 - m.fx0 >= FULL_BBOX && m.fy1 - m.fy0 >= FULL_BBOX) return; /* already tight */

    /* Contain-fit rect of the file inside the square element box (fractions). */
    var dw = m.ratio >= 1 ? 1 : m.ratio;
    var dh = m.ratio >= 1 ? 1 / m.ratio : 1;
    var padX = (1 - dw) / 2, padY = (1 - dh) / 2;

    /* Subject rect in element-box fractions. */
    var cx0 = padX + m.fx0 * dw, cx1 = padX + m.fx1 * dw;
    var cy0 = padY + m.fy0 * dh, cy1 = padY + m.fy1 * dh;
    var cwF = cx1 - cx0, chF = cy1 - cy0;

    var s = Math.min(1 / Math.max(cwF, chF), MAX_SCALE);
    var dx = -s * ((cx0 + cx1) / 2 - 0.5) * 100;
    var dy = -s * ((cy0 + cy1) / 2 - 0.5) * 100;

    img.style.setProperty('--fit-clip', 'inset(' + (cy0 * 100).toFixed(2) + '% ' + ((1 - cx1) * 100).toFixed(2) + '% ' + ((1 - cy1) * 100).toFixed(2) + '% ' + (cx0 * 100).toFixed(2) + '%)');
    img.style.setProperty('--fit-s', s.toFixed(4));
    img.style.setProperty('--fit-dx', dx.toFixed(2) + '%');
    img.style.setProperty('--fit-dy', dy.toFixed(2) + '%');
  }

  function enabled(img) {
    var root = img.closest('.nt-popcats');
    return !root || root.getAttribute('data-autofit') !== 'false';
  }

  function watch(img) {
    if (img.__ntFitWatched) return;
    img.__ntFitWatched = true;
    if (!enabled(img)) return;
    if (img.complete && img.naturalWidth) apply(img);
    /* Re-measure whenever a (new) source finishes — lazysizes swaps in the
       full-size file after the tiny preview; the last load wins. */
    img.addEventListener('load', function () { apply(img); });
  }

  function initAll(scope) {
    var container = scope && scope.querySelectorAll ? scope : document;
    var imgs = container.querySelectorAll('img.nt-popcats__img');
    Array.prototype.forEach.call(imgs, watch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('lazyloaded', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('nt-popcats__img')) watch(e.target);
  });

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
